// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"5a8f5044","91":"10833e76","316":"ecd8b7ae","347":"fd11322a","424":"bdc812dd"}[chunkId] + ".chunk.js";
};